import {Button, Menu, MenuItem} from '@material-ui/core';
import ArrowDown from '@material-ui/icons/KeyboardArrowDown';
import {SubscriptionsRouteConstants} from 'GenericTexting/Routes';
import React from 'react';
import {RouteComponentProps, withRouter} from 'react-router';
import MenuStateProvider from 'Shared/components/MenuStateProvider';
import {Scope} from 'Shared/constants/Scope';
import RequireAtLeastOneScope from 'Shared/components/RequireAtLeastOneScope';

type MessagingMenuProps = {
  scopes: Scope[];
} & RouteComponentProps;

export const MessagingMenu = (props: MessagingMenuProps) => (
  <RequireAtLeastOneScope scopes={[Scope.ViewMessages]}>
    <MenuStateProvider>
      {({open, close, anchor}) => (
        <>
          <Button
            id="administration-menu-button"
            className="my-access-menu"
            variant="text"
            onClick={event => open(event.currentTarget)}
          >
            Messaging
            <ArrowDown />
          </Button>
          <Menu
            anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
            transformOrigin={{vertical: 'top', horizontal: 'center'}}
            getContentAnchorEl={null}
            onClose={close}
            open={Boolean(anchor)}
            anchorEl={anchor}
          >
            <MenuItem
              className="my-access-menu__item"
              id="agent-administration-option"
              onClick={() => {
                props.history.push(SubscriptionsRouteConstants.MESSAGES);
                close();
              }}
            >
              Messages
            </MenuItem>
            <MenuItem
              className="my-access-menu__item"
              id="agent-administration-option"
              onClick={() => {
                props.history.push(SubscriptionsRouteConstants.CLIENT_MESSAGES);
                close();
              }}
            >
              Client Messages
            </MenuItem>
            <MenuItem
              className="my-access-menu__item"
              id="agent-administration-option"
              onClick={() => {
                props.history.push(SubscriptionsRouteConstants.CLIENTS);
                close();
              }}
            >
              Clients
            </MenuItem>
            <MenuItem
              className="my-access-menu__item"
              id="agent-administration-option"
              onClick={() => {
                props.history.push(SubscriptionsRouteConstants.MESSAGE_DISPOSITIONS);
                close();
              }}
            >
              Dispositions
            </MenuItem>
            <MenuItem
              className="my-access-menu__item"
              id="agent-administration-option"
              onClick={() => {
                props.history.push(SubscriptionsRouteConstants.KEYWORDS);
                close();
              }}
            >
              Keywords
            </MenuItem>
          </Menu>
        </>
      )}
    </MenuStateProvider>
  </RequireAtLeastOneScope>
);

export default withRouter(MessagingMenu);
